import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCommAuditTrails } from "../../../api/commAuditTrails_api";

export const getCommAuditTrailsAction = createAsyncThunk(
  "commAuditTrails/getCommAuditTrails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await getCommAuditTrails(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
